import { render, staticRenderFns } from "./applicant_detail.vue?vue&type=template&id=5792d029&scoped=true"
import script from "./applicant_detail.vue?vue&type=script&lang=ts"
export * from "./applicant_detail.vue?vue&type=script&lang=ts"
import style0 from "./applicant_detail.vue?vue&type=style&index=0&id=5792d029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5792d029",
  null
  
)

export default component.exports